import {axiosReqGet, axiosReqOther} from "./config";
import { store } from '../store/store';

const USER_TOKEN = store.getState().authentication.user;

export const Song = {
    getHomePageGenreSongs,
    getNewRelease,
    getTop20Albums,
    addSongToCrate,
    getCustomerCrates,
    renewSong,
    createSong,
    getSongEntry,
    updateSong,
    deleteSong,
    getSearchResultSongs,
    fetchSuggestions,
    getChartSongs,
    addSongToFavourite,
    getCustomerFavouriteSongs,
    getFavouriteSongs,
    searchMatches,
    getArtistSongs,
    getSongReport,
    listenSong,
    getListenSongs,
    getRecommendedSongs,
    getSectionRecommendations,
    getHomeRecommendations
}

function getListenSong(){
    const url = 'song/get-played-songs.json?store_id=1&lang_code=en';
    const data = {token:  USER_TOKEN}
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getArtistSongs(data){
    const url = 'song/get-artist-songs.json?store_id=1&lang_code=en';
    data.token =  USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getHomePageGenreSongs(){
    const url = 'song/get-index-genres-songs.json?store_id=1&lang_code=en';
    const data = {
        token: USER_TOKEN
    };
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getNewRelease(data){
    const url = 'song/get-new-release.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getTop20Albums(){
    const url = 'top20/get-tracks.json?store_id=1&lang_code=en';
    return axiosReqGet()
            .get(url)
            .then(res => {
            return res; 
        })
        .catch(err => { 
            // alert(err.response.data.message)      
            return err; 
        })
}

function addSongToCrate(songId, versionId){
    const url = 'crate/add-remove.json?store_id=id=1&lang_code=en';
    const data = {
        token: USER_TOKEN,
        songId: songId,
        versionId: versionId
    }
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function addSongToFavourite(songId){
    const url = 'favourite-song/add-remove.json?store_id=1&lang_code=en';
    const data = {
        token: USER_TOKEN,
        songId: songId
    }
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getCustomerFavouriteSongs(){
    const url = 'favourite-song/index.json?store_id=1&lang_code=en';
    const data = {
        token: USER_TOKEN
    }
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getFavouriteSongs(songId){
    const url = 'favourite-song/get-favourite-songs.json?store_id=1&lang_code=en';
    const data = {
        token: USER_TOKEN
    }
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getCustomerCrates(){
    const url = 'crate/get-crates.json?store_id=id=1&lang_code=en';
    const data = {
        token: USER_TOKEN
    }
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function renewSong(data){
    const url = 'song/renew-song.json?store_id=1&lang_code=en';
    data.token= USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function createSong(data){

    const url = 'song/create-song.json?store_id=1&lang_code=en';
    data .token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getSongEntry(data){
    const url = 'song/get-song.json?store_id=1&lang_code=en';
    data .token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function updateSong(data){
    const url = 'song/update-song.json?store_id=1&lang_code=en';
    data .token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function deleteSong(data){
    const url = 'song/delete-song.json?store_id=1&lang_code=en';
    data .token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getSearchResultSongs(data){
    const url = 'song/search.json?store_id=1&lang_code=en';
    data .token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function fetchSuggestions(data){
    const url = 'song/search-suggestion.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getChartSongs(data){
    const url = 'song/chart.json?store_id=1&lang_code=en';
    data .token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function searchMatches(data){
    const url = 'song/matchessong.json?store_id=1&lang_code=en';
    data .token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getSongReport(data){
    const url = 'song/search-report.json?store_id=1&lang_code=en';
    data .token = USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function listenSong(data){
    const url = 'song/play-song.json?store_id=1&lang_code=en';

    // duration_played_seconds/song_duration_seconds/completed are optional
    // — the backend defaults to a plain "play" (weight 1) if omitted, same
    // as before. Passing them lets the recommendation profile builder
    // weight a full listen (3x) or a >30s listen (2x) higher than a skip.
    const postData = {
        entity_id: data.entity_id,
        token: USER_TOKEN
    }
    if (data.duration_played_seconds !== undefined) {
        postData.duration_played_seconds = data.duration_played_seconds;
    }
    if (data.song_duration_seconds !== undefined) {
        postData.song_duration_seconds = data.song_duration_seconds;
    }
    if (data.completed !== undefined) {
        postData.completed = data.completed;
    }
    return axiosReqOther(url, postData, 'post').then(res => {
        return res;
    })
    .catch(err => {
        // alert(err.response.data.message)
        return err;
    });
}

function getListenSongs(){
    const url = 'song/get-played-songs.json?store_id=1&lang_code=en';
   
    const postData = {
        token: USER_TOKEN
    }
    return axiosReqOther(url, postData, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        // alert(err.response.data.message)
        return err; 
    });
}

function getRecommendedSongs(data){
    // Cut over from the deprecated live/uncached genre-overlap-only query
    // (SongHelper::recommendedSongs()) to the new precomputed, cached,
    // multi-signal recommended_for_you section. Same response shape
    // ({ songs: [...] }) as before, so no changes needed in
    // pages/recommendedSongs — it just has no `pagination` key anymore
    // (recommendations are a curated top-20, not a paginated browse), which
    // the page already handles gracefully (no Pagination control renders).
    const url = 'recommendation/get-section-recommendations.json?store_id=1&lang_code=en';

    data.token = USER_TOKEN;
    data.section = 'recommended_for_you';

    return axiosReqOther(url, data, 'post').then(res => {
        return res;
    })
    .catch(err => {
        // alert(err.response.data.message)
        return err;
    });
}

function getSectionRecommendations(section){
    const url = 'recommendation/get-section-recommendations.json?store_id=1&lang_code=en';
    const data = {
        token: USER_TOKEN,
        section: section
    }
    return axiosReqOther(url, data, 'post').then(res => {
        return res;
    })
    .catch(err => {
        // alert(err.response.data.message)
        return err;
    });
}

function getHomeRecommendations(){
    const url = 'recommendation/get-home-recommendations.json?store_id=1&lang_code=en';
    const data = {
        token: USER_TOKEN
    }
    return axiosReqOther(url, data, 'post').then(res => {
        return res;
    })
    .catch(err => {
        // alert(err.response.data.message)
        return err;
    });
}